module.exports = __webpack_public_path__ + "static/media/signuppic.76ec0be1.jpg";